export const CoreInitiativesName = 'CoreInitiatives';
